/**
 * iter45 — Extracted from LeagueDashboard.jsx.
 *
 * Permanent footer cards rendered below all tab views: Smack Stream (left)
 * + League Messages & Updates (right). Stacked on mobile, side-by-side on
 * desktop. Hidden when there's no tournament.
 *
 * iter63z'''''' — Hall of Burn widget appended under Smack Stream in the
 * left column. Shows all-time top 3 posters + top 3 reactors league-wide.
 */
import SmackStreamCard from "../SmackStreamCard";
import HallOfBurn from "../HallOfBurn";

export default function DashboardFooterCards({
    leagueId,
    me,
    isAdmin,
    smackPing,
    recentChanges,
    participants = [],
}) {
    return (
        <div className="grid lg:grid-cols-2 gap-4 mt-6" data-testid="dashboard-footer-cards">
            <div className="space-y-4">
                <SmackStreamCard
                    leagueId={leagueId}
                    me={me}
                    isAdmin={isAdmin}
                    participants={participants}
                    refreshPing={smackPing}
                />
                <HallOfBurn
                    leagueId={leagueId}
                    refreshPing={smackPing}
                />
            </div>
            <div className="brutal-card p-5 space-y-3" data-testid="dashboard-recent-changes">
                <h3 className="font-display font-extrabold text-base uppercase tracking-tight">
                    Rivalry Messages & Updates
                </h3>
                {recentChanges.length === 0 ? (
                    <p className="text-xs text-zinc-500 italic">
                        No messages yet — the admin can post updates from the Settings tab.
                    </p>
                ) : (
                    <ul className="space-y-2">
                        {recentChanges.map((c) => (
                            <li
                                key={c.id}
                                data-testid={`league-message-${c.id}`}
                                className={`brutal-card-light p-3 text-xs ${c.change_type === "admin_message" ? "border-cyber/40" : ""}`}
                            >
                                {c.change_type === "admin_message" && (
                                    <p className="text-[9px] uppercase font-bold tracking-widest text-cyber mb-1">
                                        📣 Admin
                                    </p>
                                )}
                                <p className="text-zinc-300 leading-relaxed">{c.summary}</p>
                                <p className="text-[10px] text-zinc-500 mt-1">
                                    {new Date(c.created_at).toLocaleString()}
                                </p>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
}
